import { render, staticRenderFns } from "./oweDetails.vue?vue&type=template&id=6a94dc68&"
import script from "./oweDetails.vue?vue&type=script&lang=js&"
export * from "./oweDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports